import React, { useCallback } from 'react';
import { Modal } from '../../ui';
import { useTranslation } from 'react-i18next';
import useQuizSettingsEditor from './hooks/useQuizSettingsEditor';

const QuizEdit = ({ isDialogOpen, closeDialog, quizInfo, onSave }) => {
  const { t } = useTranslation();

  const handleSave = useCallback(
    (settings) => {
      onSave(settings);
      closeDialog();
    },
    [onSave, closeDialog]
  );

  const isEditing = !!(quizInfo && Object.keys(quizInfo).length);

  const { form, handleSave: triggerSave } = useQuizSettingsEditor({
    quizSettings: quizInfo,
    onSave: handleSave,
    compact: false,
    inputSize: 'medium',
    isEditing,
  });

  return (
    <Modal
      open={isDialogOpen}
      showActions
      width='600px'
      onClose={closeDialog}
      onAccept={triggerSave}
      acceptLabel={isEditing ? t('globals.save') : t('globals.create')}
      title={isEditing ? quizInfo?.name : t('quiz.newQuiz')}
    >
      {form}
    </Modal>
  );
};

export default QuizEdit;
